<div class="progress-bar">
  <div class="progress-bar__value progress-bar__value-animate" [style.width.%]="value ?? 0"></div>
</div>
